import { computed } from '@ember/object';
import { filter, filterBy } from '@ember/object/computed';
import Em from 'ember';
export default Em.Component.extend({
  direction: 'right',
  directionClassName: computed('direction', function () {
    return `ic-popup-${this.direction}`;
  }),
  popoverClassNames: computed('directionClassName', function () {
    return `ic-popup ${this.directionClassName} is-light-theme composer-attribute-selector`;
  }),
  notRelatedObjectAttributes: filter('attributes', function (attribute) {
    return attribute.get('isRelatedObject') !== true;
  }),
  userAttributes: filter('notRelatedObjectAttributes', function (attribute) {
    return attribute.get('isUser') && !attribute.get('isUserEvent');
  }),
  companyAttributes: filterBy('notRelatedObjectAttributes', 'isCompany'),
  appAttributes: filterBy('notRelatedObjectAttributes', 'isApp'),
  eventAttributes: filterBy('notRelatedObjectAttributes', 'isUserEvent'),
  eventMetadataAttributes: filterBy('notRelatedObjectAttributes', 'isSelectedEventMetadata'),
  conversationAttributes: filterBy('notRelatedObjectAttributes', 'isConversation'),
  actions: {
    selectAttribute(attribute) {
      this.attributeSelected?.(attribute);
    }
  }
});